import { orderBy } from 'lodash-es';

import { getHoursMinutes } from 'core/date/hours-mins';

export interface ITimeInterval {
  /** start time formated hh:mm */
  startTime: string;
  /** end time formated hh:mm */
  endTime: string;
}

export function doTimeIntervalsOverlap(intervals: ITimeInterval[]) {
  // Compiler will probably optimize this.
  const hrmins = getHoursMinutes();
  const sortedByStart: ITimeInterval[] = orderBy(intervals, i => hrmins.indexOf(i.startTime));

  for (let i = 0; i < sortedByStart.length; i++) {
    const currInterval = sortedByStart[i];
    const nextInterval = sortedByStart[i + 1];
    if (nextInterval && hrmins.indexOf(currInterval.endTime) > hrmins.indexOf(nextInterval.startTime)) {
      return true;
    }
  }

  return false;
}
